export const DEFAULT_LIMIT = 25;
export const DEFAULT_PAGE = 1;
export const DEFAULT_CARD_LIMIT = 20;
export const ROUTE_CARD_LIMIT = {
    ClientDetails: 30,
    Objects: DEFAULT_LIMIT,
};
export const RESOURCE_LIMIT = 10;
export const DEFAULT_SELECT_LIMIT = 10;
